import { NgModule } from '@angular/core';
import {
  VitalColorPipe,
  VitalTrendClassPipe,
  VitalTrendContainerClassPipe,
  VitalOpacityPipe,
  VitalTrendTextPipe,
  VitalGDSColorPipe,
  VitalNewsColorPipe,
  VitalRiskTextPipe,
  VitalCpcEwsColorPipe
} from './vital-params.pipe';

@NgModule({
  declarations: [
    VitalColorPipe,
    VitalTrendClassPipe,
    VitalTrendContainerClassPipe,
    VitalOpacityPipe,
    VitalTrendTextPipe,
    VitalGDSColorPipe,
    VitalNewsColorPipe,
    VitalCpcEwsColorPipe,
    VitalRiskTextPipe
  ],
  exports: [
    VitalColorPipe,
    VitalTrendClassPipe,
    VitalTrendContainerClassPipe,
    VitalOpacityPipe,
    VitalTrendTextPipe,
    VitalGDSColorPipe,
    VitalNewsColorPipe,
    VitalCpcEwsColorPipe,
    VitalRiskTextPipe
  ]
})
export class VitalParamsPipeModule { }